/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linesheet_Status_PendingInputs */

const en_linesheet_status_pending = /** @type {(inputs: Linesheet_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awaiting approval`)
};

/**
* | output |
* | --- |
* | "Awaiting approval" |
*
* @param {Linesheet_Status_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const linesheet_status_pending = /** @type {((inputs?: Linesheet_Status_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linesheet_Status_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_linesheet_status_pending(inputs)
});